import styled from 'styled-components';

type Variante = 'primary' | 'outline' | 'danger';

const COR: Record<Variante, string> = { primary: '#0090D3', outline: '#0090D3', danger: '#F75A68' };

// Mesmo desenho do ButtonCreate (subheader-style), mas <button>: o ButtonCreate é div e não aceita disabled.
export const HeaderButton = styled.button<{ $variant?: Variante }>`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  height: 2rem;
  padding: 0 0.9rem;
  border-radius: 2rem;
  border: 1px solid ${({ $variant = 'primary' }) => COR[$variant]};
  background: ${({ $variant = 'primary' }) => ($variant === 'primary' ? COR.primary : '#fff')};
  color: ${({ $variant = 'primary' }) => ($variant === 'primary' ? '#fff' : COR[$variant])};
  font-size: 0.72rem;
  font-weight: bold;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
